var idID = {
	"codeBlock.copied": "Disalin",
	"codeBlock.copyLabel": "Salin",
	"inlineCodeBlock.copied": "Disalin",
	"inlineCodeBlock.copyLabel": "Salin kode inline"
};

export { idID as default };
